import { render, staticRenderFns } from "./GroupBuyCard.vue?vue&type=template&id=e070a920&scoped=true&"
import script from "./GroupBuyCard.vue?vue&type=script&lang=js&"
export * from "./GroupBuyCard.vue?vue&type=script&lang=js&"
import style0 from "./GroupBuyCard.vue?vue&type=style&index=0&id=e070a920&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e070a920",
  null
  
)

export default component.exports